import moment from "moment";
export function dobStringToObject(str) {
    var dob = (str === null || str === void 0 ? void 0 : str.split("-")) || [];
    if (dob.length === 2) {
        return {
            day: parseInt(dob[1], 10),
            month: parseInt(dob[0], 10),
            year: 0
        };
    }
    return {
        day: parseInt(dob[2], 10) || 0,
        month: parseInt(dob[1], 10) || 0,
        year: parseInt(dob[0], 10) || 0
    };
}
export function dobObjectToString(dob) {
    if (!dob) {
        return "";
    }
    var year = dob.year, month = dob.month, day = dob.day;
    if (year && month && day) {
        return moment(year + "-" + month + "-" + day, "YYYY-MM-DD").format("YYYY-MM-DD");
    }
    else if (month && day) {
        return moment("2020-" + month + "-" + day, "YYYY-MM-DD").format("MM-DD");
    }
    else {
        return null;
    }
}
